import { createAction, props } from '@ngrx/store';

export const saveBranding = createAction(
  '[Branding Component] Save',
  props<{ brandingData: any }>()
);

export const loadBranding = createAction('[Branding Component] Load');
